import { StyleSheet } from 'react-native';

export const tutorialHeroArtStyles = StyleSheet.create({
  root: {
    flex: 1,
    width: '100%',
  },
  content: {
    flexGrow: 1,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 8,
  },
});
